function normalizeSegmentationInput(segmentationInput) {
    const { segmentationId, representation } = segmentationInput;
    return {
        segmentationId,
        cachedStats: {},
        segmentLabels: {},
        label: null,
        segmentsLocked: new Set(),
        type: representation.type,
        activeSegmentIndex: 1,
        representationData: {
            [representation.type]: {
                ...representation.data,
            },
        },
    };
}
export default normalizeSegmentationInput;
//# sourceMappingURL=normalizeSegmentationInput.js.map